import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { authQueryKeys } from './auth';
import { billingQueryKeys } from './billing';
import { configQueryKeys } from './config';
import { installationQueryKeys } from './installation';
import { repoQueryKeys } from './repo';

export const queryKeys = mergeQueryKeys(
  installationQueryKeys,
  authQueryKeys,
  repoQueryKeys,
  billingQueryKeys,
  configQueryKeys,
);
